module.exports = __webpack_public_path__ + "img/eci.fc683224.svg";